import { useState, useEffect } from 'react'
import { FaSignInAlt } from 'react-icons/fa'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { login, reset } from '../features/auth/authSlice'
import Spinner from '../components/Spinner'
import { Container } from 'react-bootstrap'
import { Helmet } from 'react-helmet';

function Login() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  })

  const { email, password } = formData

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { user, isLoading, isError, isSuccess, message } = useSelector(
      (state) => state.auth
  )

  useEffect(() => {
    if (isError) {
      toast.error(message.error);
    }

    if (isSuccess || user) {
      // Jump to My Posts page
      navigate("/userHome");
    }

    dispatch(reset())
  }, [user, isError, isSuccess, message, navigate, dispatch])

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }))
  }

  const onSubmit = (e) => {
    e.preventDefault()
    if (!email || !password) {
      toast.error('Please enter your email and password!')
      return
    }

    const userData = {
      email,
      password,
    }

    dispatch(login(userData))

  }

  if (isLoading) {
    return <Spinner />
  }

  return (
      <Container style={{
        width: "400px",
        backgroundColor: "#f0f2f5",
        padding: "30px",
        borderRadius: "10px" }}>

        <Helmet>
          <title>Login - Pop Zombie</title>
          <meta name="description" content="Login to the application to access your account and manage your posts." />
        </Helmet>


        <section className='heading'>
          <h3 style={{
            color: "#15a2fa",
            marginBottom: "15px" }}>
            <FaSignInAlt style={{ marginRight: "10px" }} /> Login
          </h3>
          <h4 style={{
            color: "#050505"
          }}>Login to post</h4>
        </section>

        <section className='form'>
          <form onSubmit={onSubmit}>
            <div className='form-group'>
              <input
                  type='email'
                  className='form-control'
                  id='email'
                  name='email'
                  value={email}
                  placeholder='Enter your email'
                  onChange={onChange}
                  required
                  style={{
                    backgroundColor: "#ffffff",
                    border: "none",
                    borderRadius: "5px",
                    padding: "10px",
                    marginBottom: "15px"
              }}
              />
            </div>
            <div className='form-group'>
              <input
                  type='password'
                  className='form-control'
                  id='password'
                  name='password'
                  value={password}
                  placeholder='Enter password'
                  onChange={onChange}
                  required
                  style={{
                    backgroundColor: "#ffffff",
                    border: "none",
                    borderRadius: "5px",
                    padding: "10px" }}
              />
            </div>

            <div className='form-group'>
              <button type='submit' className='btn btn-block' style={{
                backgroundColor: "#f0f2f5",
                color: "#15a2fa",
                borderRadius: "5px",
                padding: "10px",
                border: "none",
                marginTop: "15px" }}>
                Submit
              </button>
            </div>
          </form>
        </section>
      </Container>
  )
}

export default Login
